import { PricingEcSuitePage } from './PricingEcSuitePage';

document.addEventListener('DOMContentLoaded', function () {
  window.Webflow ||= [];

  window.Webflow.push(async () => {
    const app = new PricingEcSuitePage();
    app.init();
    document.documentElement.classList.add('webflow-loaded');
  });


});
